
import { httpsCallable } from 'firebase/functions';
import { FirebaseService } from '../utils/firebase'
;
import { clearCalendarSelection } from '../store/selection.store';
import { settings } from '../store/settings.store';
import { checkout } from '../store/checkout.store';

import { showMessage } from './message.modal';
import { OrderInfoRow } from '../utils/models';


let checkoutEl: HTMLTambrCheckoutElement;
let addOnsSelectDialogEl: HTMLTambrCheckoutAddOnsSelectElement;
let notesDialogEl: HTMLTambrCheckoutNotesElement;
let confirmDialogEl: HTMLTambrConfirmationDialogElement;


export function openCheckout() {
  if ( document.getElementsByTagName('tambr-checkout').length ) return;
  checkoutEl = document.createElement('tambr-checkout');
  document.body.appendChild( checkoutEl );
  document.body.style.overflow = 'hidden';  
}


export function checkoutSuccess( orderId: string, orderInfo: OrderInfoRow[] ) {
  const message = `Your order ${orderId} has been successfully submitted.`;
  confirmCloseCheckout();
  showMessage( message, 'Thank you!', true, orderInfo );
  clearCalendarSelection();
}

export function checkoutError( 
  message: string = 'Something went wrong. Please try again later.',
  header: string = 'Error',
  closeCheckout: boolean = true
) {
  showMessage( message, header, true );
  if ( closeCheckout ) {
    closeAddOnsDialog();
    closeCheckoutNoteModal();
    confirmCloseCheckout();
    clearCalendarSelection();
  } 
}



/**
 * Cancel checkout
 */

export function closeCheckout() { 
  if ( checkout.checkoutId ) {
    openCancelConfirmationDialog();
  } else {
    confirmCloseCheckout();
  }    
}


export function confirmCloseCheckout() {
  if ( document.getElementsByTagName('tambr-checkout').length ) {
    checkoutEl.remove();
    document.body.style.overflow = settings.pageBodyOverflow; 
    clearCalendarSelection(); 
  }
}


function openCancelConfirmationDialog() {
  if ( document.getElementsByTagName('tambr-confirmation-dialog').length ) return;
  
  confirmDialogEl = document.createElement('tambr-confirmation-dialog');
  confirmDialogEl.message = `Are you sure you would like to cancel this checkout session?`;
  confirmDialogEl.confirmText = 'Cancel checkout';
  confirmDialogEl.cancelText = 'Continue with checkout';

  confirmDialogEl.addEventListener( 'tambrConfirmationDialogResponse', async (response: any) => {
    confirmDialogEl.remove(); 
    if ( response.detail === 'confirm' ) {
      await cancelCheckout();
      confirmCloseCheckout();
    }
  });
  document.body.appendChild(confirmDialogEl);  
}


export async function cancelCheckout() {
  checkout.checkoutCancelLoading = true;
  try {
    const checkoutCancel = httpsCallable( FirebaseService.functions, 'checkout_cancel' );
    await checkoutCancel({ businessId: settings.businessId, checkoutId: checkout.checkoutId });
    checkout.checkoutId = null;
    checkout.checkoutCancelLoading = false;   
  } catch (e) {
    console.error(e);
    checkout.checkoutCancelLoading = false;
  }  
}



/**
 * Logout
 */

export function checkoutLogout() {
  if ( document.getElementsByTagName('tambr-confirmation-dialog').length ) return;

  confirmDialogEl = document.createElement('tambr-confirmation-dialog');
  confirmDialogEl.message = `Are you sure you would like to cancel this checkout session and log out?`;
  confirmDialogEl.confirmText = 'Log out';
  confirmDialogEl.cancelText = 'Continue with checkout';

  confirmDialogEl.addEventListener( 'tambrConfirmationDialogResponse', async (response: any) => {
    confirmDialogEl.remove(); 
    if ( response.detail === 'confirm' ) {
      if ( checkout.checkoutId ) {
        await cancelCheckout();
        confirmCloseCheckout();
      }
      await confirmCheckoutLogout();
    }
  });

  document.body.appendChild( confirmDialogEl ); 
}


async function confirmCheckoutLogout() {
  try {
    await FirebaseService.auth.signOut();
  } catch (e) {
    console.error(e);
    checkoutError();
  }  
}



/**
 * Add-ons
 */

export function openAddOnsModal() {
  addOnsSelectDialogEl = document.createElement('tambr-checkout-add-ons-select');
  addOnsSelectDialogEl.addEventListener( 'tambrCheckoutAddOnsDialogClose', () => closeAddOnsDialog() );
  addOnsSelectDialogEl.addEventListener( 'tambrCheckoutAddOnsDialogError', () => handleAddOnsDialogError() );
  document.body.appendChild( addOnsSelectDialogEl );
}

function closeAddOnsDialog() {
  if ( document.getElementsByTagName('tambr-checkout-add-ons-select').length ) {
    document.body.removeChild( addOnsSelectDialogEl );
  }
}

function handleAddOnsDialogError() {
  return checkoutError();
}



/**
 * Note
 */

export function openCheckoutNoteModal() {
  notesDialogEl = document.createElement('tambr-checkout-notes');
  notesDialogEl.addEventListener( 'tambrCheckoutNotesDialogClose', () => closeCheckoutNoteModal() );
  document.body.appendChild( notesDialogEl );
}

function closeCheckoutNoteModal() {
  if ( document.getElementsByTagName('tambr-checkout-notes').length ) {
    document.body.removeChild( notesDialogEl );
  }
}